import { useEsigningProviders } from 'app/domains/esigning/hooks/useEsigningProviders';
import { sortAuthenticationModes } from './utils';
export function useEsigningAuthenticationModes() {
    const { connectedProvider } = useEsigningProviders();
    const authModes = (connectedProvider === null || connectedProvider === void 0 ? void 0 : connectedProvider.authenticationModes) || [];
    const sortedAuthenticationModes = sortAuthenticationModes(authModes);
    return { authenticationModes: sortedAuthenticationModes };
}
